import { render, staticRenderFns } from "./RequestCardTalentNew.vue?vue&type=template&id=68e54b40&scoped=true"
import script from "./RequestCardTalentNew.vue?vue&type=script&lang=ts"
export * from "./RequestCardTalentNew.vue?vue&type=script&lang=ts"
import style0 from "./RequestCardTalentNew.vue?vue&type=style&index=0&id=68e54b40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e54b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68e54b40')) {
      api.createRecord('68e54b40', component.options)
    } else {
      api.reload('68e54b40', component.options)
    }
    module.hot.accept("./RequestCardTalentNew.vue?vue&type=template&id=68e54b40&scoped=true", function () {
      api.rerender('68e54b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/requests/RequestCardTalentNew.vue"
export default component.exports